import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Observable } from "rxjs";
import { AdmGroupEx } from "../../api/models/adm-group-ex";
import { AdmTable } from "../../api/models/adm-table";
import { AdmTableColumn } from "../../api/models/adm-table-column";
import { DialogResult, DialogResultType } from "../DialogResult";
import { mergeTableSelection } from "./adm-group-table-order";

export interface AdmGroupDialogData {
  group: AdmGroupEx;
  tables: AdmTable[];
  columns: AdmTableColumn[];
  tableName: (id: number) => string;
}

// Admin ADM Groups > one named set of tables (and optional per-table column allowlist) offered to plan types.
@Component({
  selector: "adm-group-dialog",
  templateUrl: "./adm-group-dialog.component.html",
})
export class AdmGroupDialogComponent {
  public result: AdmGroupEx;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };

  constructor(public dialogRef: MatDialogRef<AdmGroupDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AdmGroupDialogData) {
    this.result = { ...data.group, tableIds: [...(data.group.tableIds || [])], allowedColumnIds: [...(data.group.allowedColumnIds || [])] };
  }

  get isNew(): boolean {
    return !this.data.group.admGroupId;
  }

  // Columns that can be listed in the allowlist: those of the tables currently in the Group.
  get allowlistCandidates(): AdmTableColumn[] {
    const included = new Set(this.result.tableIds || []);
    return this.data.columns.filter((c) => included.has(c.admTableId) && c.selectable);
  }

  columnLabel(c: AdmTableColumn): string {
    return `${this.data.tableName(c.admTableId)}.${c.outputName || c.columnName}`;
  }

  // The order of result.tableIds IS the display order saved (AdminAdmGroupController.SaveGroup writes
  // SortOrder = array index) - this just lets the admin drag it into the order subscribers should see
  // (e.g. Job Postings before Job Attributes) instead of leaving it at whatever order the picker above added
  // tables in.
  // The dropdown reports the selection in ITS option order; merging keeps the order the admin arranged.
  onTablesSelected(selected: number[]): void {
    this.result.tableIds = mergeTableSelection(this.result.tableIds || [], selected);
  }

  dropTable(event: CdkDragDrop<number[]>): void {
    moveItemInArray(this.result.tableIds, event.previousIndex, event.currentIndex);
  }

  onSave(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  static showDialog(dialog: MatDialog, data: AdmGroupDialogData): Observable<DialogResult> {
    return dialog.open(AdmGroupDialogComponent, { disableClose: false, width: "800px", data }).afterClosed();
  }
}
